import { render } from "./TagContainer.vue?vue&type=template&id=67b51caf&scoped=true"
import script from "./TagContainer.vue?vue&type=script&lang=js"
export * from "./TagContainer.vue?vue&type=script&lang=js"

import "./TagContainer.vue?vue&type=style&index=0&id=67b51caf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b51caf"]])

export default __exports__